import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'


export const getDriverDetail = createAsyncThunk('DriverStatusDashboard/getDriverDetail', async (GetDriver) => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/GetTableSummaryDriver', GetDriver, { mode: 'cors' })

  return response.data
})
 
// export const getBookings = createAsyncThunk('UpcomingBooking/getBookings', async (params) => {
     
//     const response = await axios.post('https://api.zasway.com:8443/Booking/GetDriverUpcomingBooking', params, {mode:'cors'})
     
//     return response.data
// })

export const GetDocumentDetailsByOwnerType = createAsyncThunk('appDriver/GetDocumentDetailsByOwner', async (Owner) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetDocumentSummaryByOwnerType', Owner, { mode: 'cors' })
  return response.data
})
export const AddRideLocationLog = createAsyncThunk('UpcomingBooking/AddRideLocationLog ', async (params) => {

  const response = await axios.post('https://api.zasway.com:8443/Booking/AddLiveLocationLog', params, { mode: 'cors' })

  return response.data
})
export const CheckLocation = createAsyncThunk('UpcomingBooking/CheckLocation', async (params) => {

  const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingLiveLocationList', params, { mode: 'cors' })

  return response.data
})

export const updateDriverStatus = createAsyncThunk('updatedriver/updatePersonalProfile', async (params) => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/UpdateDriverStatus', params, { mode: 'cors' })

  return response.data
})

// Hyde Park Driver App heartbeat for the Dispatch Allocate list ("app open"). params: { companyID, driverID, isAppOpen }
export const updateDriverPresence = createAsyncThunk('UserDropDown/updateDriverPresence', async (params) => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/UpdateDriverPresence', params, { mode: 'cors' })

  return response.data
})

export const getchatcount = createAsyncThunk('DriverStatusDashboard/getchatcount', async (GetDriver) => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/GetChatCount', GetDriver, { mode: 'cors' })

  return response.data
})

export const GetUpdateStatusOfUnreadMessagesForDriver = createAsyncThunk('commonLocation/UpdateStatusOfUnreadMessagesForDriver', async (GetClient) => {
  const response = await axios.post('https://api.zasway.com:8443/Staff/UpdateStatusOfUnreadMessagesForDriver', GetClient, { mode: 'cors' })

  return response.data
})

export const getLogo = createAsyncThunk('driverProfile/GetTableSummary', async (params) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetSystemLogo', params, { mode: 'cors' })

  return response.data
})
export const AddDriverShift = createAsyncThunk('updatedriver/updatePersonalProfile ', async (params) => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/AddDriverShift', params, { mode: 'cors' })

  return response.data
})
export const updateBookingStatusOnRoute = createAsyncThunk('updatedriver/updateBookingStatusOnRoute ', async (params) => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/UpdateBookingStatusForJourney', params, { mode: 'cors' })

  return response.data
})

export const setUStatus = createAsyncThunk('DriverStatusDashboard/setStatus', async (status) => {

  return status
})

export const GetDrNotifications = createAsyncThunk('UpcomingBooking/GetBookingEditNotif ', async (params) => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/GetDriverNotifications', params, { mode: 'cors' })

  return response.data

})
export const setIsNotified = createAsyncThunk('UpcomingBooking/GetBookingEditNotif ', async (params) => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/UpdateIsNotified', params, { mode: 'cors' })

  return response.data

})
export const UserDropDownStoreSlice = createSlice({
  name: 'UserDropDownStoreSlice',
  initialState: {
    data: [],
    NotificationData: [],
    userStatus: false
  },
  reducers: {},
  extraReducers: builder => {
    builder

      .addCase(getDriverDetail.fulfilled, (state, action) => {
        state.data = action.payload.data
      })
      .addCase(setUStatus.fulfilled, (state, action) => {
        state.userStatus = action.payload.status
      })
      .addCase(GetDrNotifications.fulfilled, (state, action) => {
        state.NotificationData = action.payload
      })
    //   .addCase(getBookings.fulfilled, (state, action) => {

    //     state.data = action.payload
    // })
  }
})
export default UserDropDownStoreSlice.reducer